// extracted by mini-css-extract-plugin
module.exports = {"block":"Block_block__18o1n","text":"Block_text__1efO8","full":"Block_full__1tbsl","img":"Block_img__31qzk"};